import React from 'react'

export default function NotificationItem(props) {
    // props
    const {
        dataItem,

        handleNotificationClick,
        handleNotificationChange
    } = props

    return (
        <React.Fragment>
            {
                /* item */
                (dataItem?.event_name === "order_email" && dataItem?.send_email_to === "User") ? ( // ORDER CONFIRMATION
                    <div className="conl-item">
                        <div className="conli-inner d-flex align">
                            {/* text-sec */}
                            <div className="text-sec media-body pe-2 pe-lg-4" onClick={ev => handleNotificationClick(ev, dataItem.template_id)}>
                                <div className="inner d-flex">
                                    {/* icon */}
                                    <div className="icon-sec">

                                    </div>

                                    {/* text */}
                                    {/* <div className="text-sec media-body ms-2"> */}
                                    <div className="text-sec media-body cursor-pointer">
                                        {/* head */}
                                        <p className="head st-fw-600 st-fs-16 mb-2">
                                            Order confirmation
                                            <span className="edit-text st-fw-400 ms-2">Edit</span>
                                        </p>

                                        {/* desc */}
                                        <p className="desc">
                                            Sent to customer after successful order placement to acknowledge its receipt. This email contains information about order items, shipping, billing, and order status.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* right sec */}
                            <div className="right-sec">
                                <div className="inner d-flex">
                                    {/* btn */}
                                    <button className="st-btn st-btn-sm me-3 me-lg-4" onClick={ev => handleNotificationClick(ev, dataItem.template_id)}>
                                        Edit
                                    </button>

                                    {/* toggle icon */}
                                    <div className="switch-btn position-relative" style={{ top: 2 }}>
                                        <label className="st-switch-input-lg st-switch-success d-inline-flex align-items-center">
                                            <input
                                                className="d-none"
                                                type="checkbox"
                                                // name="switch"
                                                checked={dataItem.status}
                                                onChange={ev => handleNotificationChange(ev, dataItem.template_id)}
                                            />
                                            <span className="round-outer">
                                                <span className="round d-block"></span>
                                            </span>
                                        </label>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                ) : null
            }
            {
                /* item */
                (dataItem?.event_name === "order_status_change") ? ( // ORDER STATUS CHANGED
                    <div className="conl-item">
                        <div className="conli-inner d-flex align">
                            {/* text-sec */}
                            <div className="text-sec media-body pe-2 pe-lg-4" onClick={ev => handleNotificationClick(ev, dataItem.template_id)}>
                                <div className="inner d-flex">
                                    {/* icon */}
                                    <div className="icon-sec">

                                    </div>

                                    {/* text */}
                                    {/* <div className="text-sec media-body ms-2"> */}
                                    <div className="text-sec media-body cursor-pointer">
                                        {/* head */}
                                        <p className="head st-fw-600 st-fs-16 mb-2">
                                            Order status changed
                                            <span className="edit-text st-fw-400 ms-2">Edit</span>
                                        </p>

                                        {/* desc */}
                                        <p className="desc">
                                            Sent on the order’s status change to inform the customer about the progress in order fulfillment.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* right sec */}
                            <div className="right-sec">
                                <div className="inner d-flex">
                                    {/* btn */}
                                    <button className="st-btn st-btn-sm me-3 me-lg-4" onClick={ev => handleNotificationClick(ev, dataItem.template_id)}>
                                        Edit
                                    </button>

                                    {/* toggle icon */}
                                    <div className="switch-btn position-relative" style={{ top: 2 }}>
                                        <label className="st-switch-input-lg st-switch-success d-inline-flex align-items-center">
                                            <input
                                                className="d-none"
                                                type="checkbox"
                                                // name="switch"
                                                checked={dataItem.status}
                                                onChange={ev => handleNotificationChange(ev, dataItem.template_id)}
                                            />
                                            <span className="round-outer">
                                                <span className="round d-block"></span>
                                            </span>
                                        </label>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                ) : null
            }
            {
                /* item */
                (dataItem?.event_name === "order_shipped") ? ( // ORDER SHIPPED
                    <div className="conl-item">
                        <div className="conli-inner d-flex align">
                            {/* text-sec */}
                            <div className="text-sec media-body pe-2 pe-lg-4" onClick={ev => handleNotificationClick(ev, dataItem.template_id)}>
                                <div className="inner d-flex">
                                    {/* icon */}
                                    <div className="icon-sec">

                                    </div>

                                    {/* text */}
                                    {/* <div className="text-sec media-body ms-2"> */}
                                    <div className="text-sec media-body cursor-pointer">
                                        {/* head */}
                                        <p className="head st-fw-600 st-fs-16 mb-2">
                                            Order shipped
                                            <span className="edit-text st-fw-400 ms-2">Edit</span>
                                        </p>

                                        {/* desc */}
                                        <p className="desc">
                                            Sent when a tracking number to the order is assigned or when the order’s status is changed to “Shipped” to notify the customer that the purchased items are on their way.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* right sec */}
                            <div className="right-sec">
                                <div className="inner d-flex">
                                    {/* btn */}
                                    <button className="st-btn st-btn-sm me-3 me-lg-4" onClick={ev => handleNotificationClick(ev, dataItem.template_id)}>
                                        Edit
                                    </button>

                                    {/* toggle icon */}
                                    <div className="switch-btn position-relative" style={{ top: 2 }}>
                                        <label className="st-switch-input-lg st-switch-success d-inline-flex align-items-center">
                                            <input
                                                className="d-none"
                                                type="checkbox"
                                                // name="switch"
                                                checked={dataItem.status}
                                                onChange={ev => handleNotificationChange(ev, dataItem.template_id)}
                                            />
                                            <span className="round-outer">
                                                <span className="round d-block"></span>
                                            </span>
                                        </label>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                ) : null
            }
        </React.Fragment>
    )
}
